import IframeActions from './IframeActions';

export default IframeActions;
